// extracted by mini-css-extract-plugin
module.exports = {"content":"_2V2r1_"};